document.addEventListener('DOMContentLoaded', function() {
  console.log("---- CUSTOM MYBAKER CODE LOADED ----");

  //Specific for the "Digit Cake" options.
  // Define the function to show or hide div with id "digit_two-0-1" based on clicked div's class
  function handleDigitCakeClick() {
    const targetDiv = document.getElementById('digit_two-0-1');
    const containerDiv = targetDiv.parentElement.parentElement.parentElement;
    
    if (this.classList.contains('opt--one-digit')) {
      containerDiv.style.display = 'none';
    } else if (this.classList.contains('opt--two-digits')) {
      containerDiv.style.display = 'block';
    }
  }

  // Set up a mutation observer to detect when the elements are added to the DOM
  const observer = new MutationObserver(function(mutations) {
    const oneDigit = document.querySelector('.opt--one-digit');
    const twoDigits = document.querySelector('.opt--two-digits');
    const targetDiv = document.getElementById('digit_two-0-1');

    if (oneDigit && twoDigits && targetDiv) {
      // Hide div with id "digit_two-0-1" by default
      targetDiv.parentElement.parentElement.parentElement.style.display = 'none';
      
      // Add click event listeners to .opt--one-digit and .opt--two-digits elements
      oneDigit.addEventListener('click', handleDigitCakeClick);
      twoDigits.addEventListener('click', handleDigitCakeClick);

      // Disconnect the observer once the elements are found and click listeners are added
      observer.disconnect();
    }
  });

  // Observe changes in the DOM
  observer.observe(document.body, { childList: true, subtree: true });
});
